export default __webpack_public_path__ + "static/media/GuyAnimation10.4ae7db47.svg";